import React from 'react'
import { Link } from 'react-router-dom';
import './counters.css'
import Counter from '../counter/Counter'

function Counters({posts, cats, users}) {
    return (
        <div className="counters">
            <Link to="/" ><Counter title="Posts" count={posts ? posts : 0} /></Link>
            <Link to="/admin/categories" ><Counter title="Categories" count={cats ? cats : 0} /></Link>
            <Link to="/admin/users" ><Counter title="Users" count={users ? users : 0} /></Link>
        </div>
    )
}

export default Counters 
